<template>
  <div>
    <!-- file identification -->
    <ak-pack class="two-thirds" spacing="tiny">
      <!-- file selector type -->
      <ak-pack-item class="one-whole">
        <ak-field label="Upload file name" margin-bottom="mb-small" required>
          <template #helper>
            <div class="text-small text-nowrap">
              The name includes a file extension<br />The following file
              extensions are supported: <strong>.csv, .json</strong>
            </div>
          </template>
          <ak-select
            v-model="fileFilter"
            :options="fileFilters"
            track-by="value"
            label="label"
            placeholder="Select Operator"
            required
          />
        </ak-field>
      </ak-pack-item>
    </ak-pack>
    <ak-pack>
      <!-- is configurable -->
      <ak-pack-item
        v-if="fileFilter && fileFilter.configurables.is"
        class="one-half mb-small"
      >
        <ak-input
          v-model="operation.fileFilterConfiguration.is"
          placeholder="Enter upload filename"
          required
          maxlength="100"
        />
      </ak-pack-item>
      <!-- contains configurable -->
      <ak-pack-item
        v-if="fileFilter && fileFilter.configurables.contains"
        class="one-half mb-small"
      >
        <ak-input
          v-model="operation.fileFilterConfiguration.contains"
          placeholder="Enter contains term"
          required
          maxlength="100"
        />
      </ak-pack-item>
      <!-- starts with configurable -->
      <ak-pack-item
        v-if="fileFilter && fileFilter.configurables.startsWith"
        class="one-half mb-small"
      >
        <ak-input
          v-model="operation.fileFilterConfiguration.startsWith"
          placeholder="Enter starts with term"
          required
          maxlength="100"
        />
      </ak-pack-item>
      <!-- ends with configurable -->
      <ak-pack-item
        v-if="fileFilter && fileFilter.configurables.endsWith"
        class="one-half mb-small"
      >
        <ak-input
          v-model="operation.fileFilterConfiguration.endsWith"
          placeholder="Enter ends with term"
          required
          maxlength="100"
        />
      </ak-pack-item>
    </ak-pack>
  </div>
</template>

<script>
import { computed, defineComponent } from 'vue'

export default defineComponent({
  name: 'AkIntegrationSFTPFileFilter',
  props: {
    service: {
      required: true,
      type: Object,
    },
  },
  setup(props) {
    /**
     * Operation configuration
     * @type {RefTypes.ComputedRef<*>}
     */
    const operation = props.service.getOperation()

    /**
     * Supported file filters
     * @type {[{configurables: {is: boolean}, label: string, value: string},{configurables: {contains: boolean}, label: string, value: string},{configurables: {startsWith: boolean}, label: string, value: string},{configurables: {endsWith: boolean}, label: string, value: string},{configurables: {endsWith: boolean, startsWith: boolean}, label: string, value: string}]}
     */
    const fileFilters = [
      {
        label: 'is',
        value: 'is',
        configurables: {
          is: true,
        },
      },
      {
        label: 'contains',
        value: 'contains',
        configurables: {
          contains: true,
        },
      },
      {
        label: 'starts with',
        value: 'starts-with',
        configurables: {
          startsWith: true,
        },
      },
      {
        label: 'ends with',
        value: 'ends-with',
        configurables: {
          endsWith: true,
        },
      },
      {
        label: 'starts with and ends with',
        value: 'starts-with-ends-with',
        configurables: {
          startsWith: true,
          endsWith: true,
        },
      },
    ]

    /**
     * The file filter type
     * @type {WritableComputedRef<T>}
     */
    const fileFilter = computed({
      get: () =>
        fileFilters.find((selector) => selector.value === operation.fileFilter),
      set: (selected) => selected && (operation.fileFilter = selected.value),
    })

    return {
      operation,
      fileFilters,
      fileFilter,
    }
  },
})
</script>
